import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import FieldErrorMessage from "../Utils/FieldErrorMessage";
import ReCAPTCHA from 'react-google-recaptcha';
import {toast, ToastContainer} from "react-toastify";

const ResetPasswordForm = ({ onSubmit,userId }) => {
    const navigate = useNavigate();
  

    const [captchaValue, setCaptchaValue] = useState(null);
        const [errors, setErrors] = useState([]);

       const [old_password, setOldPassword] = useState('');
       const [new_password, setNewPassword] = useState('');
       const [confirm_password, setConfirmPassword] = useState('');

    const handleCaptchaChange = (value) => {
        console.log("Captcha value:", value);
        setCaptchaValue(value);
    };

    const submit = (e) => {
         e.preventDefault(); 
        //  alert(userId);

         const data={'userId':userId,'old_password':old_password,'new_password':new_password,'confirm_password':confirm_password};

        //  console.log(data);


           axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/reset-password`, data)
            .then(({data}) => {
              if(data==true){
                navigate('/login');
                toast.success('Register Successfully');
                 window.location.reload(); 
              }
            }).catch(error => {
            if (error.response.data.status === false) {
                setErrors(error.response.data);
            }
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
         })
    }

    return (
        <div className="col-12 col-md-6 login_right">
            <div className="card">
                <div className="card-body">
                    <h3 className='text-center'>Personnel Management Information System (PMIS)</h3>
                    <h4 className='text-center mb-5'>পাসওয়ার্ড রিসেট</h4>

                    <form onSubmit={submit}>
                        {/* unique_id is hidden */}
                        {/* <input type="hidden" {...register("unique_id")} /> */}

                        <div className="mb-5">
                            <label className="form-label">পুরাতন পাসওয়ার্ড</label>
                            <input required type="password" className="form-control" value={old_password}   onChange={(e) => setOldPassword(e.target.value)} />
                            <FieldErrorMessage errors={errors} name='old_password' />
                            {/* <FieldErrorMessage errors={errors} name='old_pass_check' /> */}

                        </div>

                        <div className="mb-5">
                            <label required className="form-label">নতুন পাসওয়ার্ড</label>
                              <input type="password" className="form-control" value={new_password}  onChange={(e) => setNewPassword(e.target.value)} />
                            <FieldErrorMessage errors={errors} name='password' />
                        </div>

                        <div className="mb-5">
                            <label className="form-label">নিশ্চিত করুন পাসওয়ার্ড</label>
                               <input required type="password" className="form-control" value={confirm_password}  onChange={(e) => setConfirmPassword(e.target.value)} />
                            <FieldErrorMessage errors={errors} name='confirm_password' />
                        </div>

                        {/* <ReCAPTCHA
                            sitekey="YOUR_SITE_KEY_HERE"
                            onChange={handleCaptchaChange}
                        /> */}

                        <div className='d-flex justify-content-between align-items-center mb-2'>
                            <p className='m-0' style={{ cursor: 'pointer' }} onClick={() => navigate('/signup')}>
                                রেজিস্ট্রেশন করুন
                            </p>
                            <button type="submit" className="login_submit rounded border-0">
                                প্রবেশ করুন
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordForm;
